import GetLectureLessonHistoryPagedListRequestModelBase from '../_generated/modelBases/get-lecture-lesson-history-paged-list-request-model-base';

export default class GetLectureLessonHistoryPagedListRequestModel extends GetLectureLessonHistoryPagedListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
